import React from 'react';
import { __ } from 'artsteps2-common';
import { getUIProperty } from '../../../../reducers';
import { setUIProperty } from '../../../../actions';
import { compose, withState, withDispatch, withLifecycle } from '../../../../enhancers';
import wallPlacementImage from '../../../../styles/images/controls/place_wall.png';
import doorPlacementImage from '../../../../styles/images/controls/place_door.png';
import Dialog from '../../../generic/Dialog';

export const ExhibitionSpacePanelView = ({
  placing = false,
  placingWall = false,
  placingDoor = false,
  onToggleWallPlacement = () => Promise.resolve(false),
  onToggleDoorPlacement = () => Promise.resolve(false),
  requestIsEmpty,
  openDialog = () => Promise.resolve(false),
  closeDialog = () => Promise.resolve(false),
  requestingIsEmpty = () => Promise.resolve(false),
  onDeleteExhibition = () => Promise.resolve(false),
  onTemplateRemove = () => Promise.resolve(false),
  selectDoor = () => Promise.resolve(false),
  selectWall = () => Promise.resolve(false),
  isExhibitionEmpty,
  displayDialog = false,
  hasTemplate = false,
  selectedStructure,
  onDelete,
  changeTimestamp,
  keyboardCapture,
}) => {
  const handleClick = placementFunc => {
    requestIsEmpty();
    placementFunc();
  };

  const placeStructure = () => {
    switch (selectedStructure) {
      case 'Door':
        onToggleDoorPlacement();
        break;
      case 'Wall':
        onToggleWallPlacement();
        break;
      default:
        break;
    }
  };

  return (
    <div className="exhibition-space-editor">
      <div className="toolbar-section">
        <h4>{__('construction_tools')}</h4>
        <div className="construction-list">
          <div
            role="button"
            tabIndex={0}
            className={`item ${placingWall ? 'selected' : ''} ${
              placing && !placingWall ? 'inactive' : ''
            }`}
            onKeyPress={event => event.keyCode === 13 && handleClick(onToggleWallPlacement)}
            onClick={() => selectWall() && handleClick(onToggleWallPlacement)}
            data-tooltip={__(placingWall ? 'stop_wall_placement' : 'start_wall_placement')}
            data-inverted
            data-position="top center"
          >
            <img
              className="ui image tiny centered"
              src={wallPlacementImage}
              alt={__('place_wall')}
            />
          </div>
          <div
            role="button"
            tabIndex={0}
            className={`item ${placingDoor ? 'selected' : ''} ${
              placing && !placingDoor ? 'inactive' : ''
            }`}
            data-tooltip={__(placingDoor ? 'stop_door_placement' : 'start_door_placement')}
            data-inverted
            data-position="top center"
            onKeyPress={event => event.keyCode === 13 && handleClick(onToggleDoorPlacement)}
            onClick={() => selectDoor() && handleClick(onToggleDoorPlacement)}
          >
            <img
              className="ui image tiny centered"
              src={doorPlacementImage}
              alt={__('place_door')}
            />
          </div>
          <Dialog
            open={displayDialog}
            title={__('article_deletion')}
            message={__('confirm_article_deletion')}
            type="warning"
            onConfirm={() =>
              onTemplateRemove() && onDeleteExhibition() && closeDialog() && placeStructure()
            }
            onReject={() => closeDialog()}
          />
        </div>
      </div>
    </div>
  );
};

const mapState = (state, { exhibitionId }) => ({
  placing: !!getUIProperty(state, `exhibitions/${exhibitionId}/placingStructure`),
  placingWall: getUIProperty(state, `exhibitions/${exhibitionId}/placingStructure`) === 'Wall',
  placingDoor: getUIProperty(state, `exhibitions/${exhibitionId}/placingStructure`) === 'Door',
  requestingIsEmpty: getUIProperty(state, `exhibitions/${exhibitionId}/requestingIsEmpty`),
  isExhibitionEmpty: !!getUIProperty(state, `exhibitions/${exhibitionId}/isEmpty`),
  displayDialog: getUIProperty(state, `exhibitions/${exhibitionId}/displayStructureDialog`),
  hasTemplate:
    (!!getUIProperty(state, `exhibitions/${exhibitionId}/templatePath`) ||
      !!getUIProperty(state, `exhibitions/${exhibitionId}/import/templatePath`)) &&
    (getUIProperty(state, `exhibitions/${exhibitionId}/import/templatePath`) === 'default' ||
      getUIProperty(state, `exhibitions/${exhibitionId}/templatePath`) !== 'default'),
  selectedStructure: getUIProperty(state, `exhibitions/${exhibitionId}/selectedStructure`),
  onDelete: !!getUIProperty(state, `exhibitions/${exhibitionId}/onDelete`),
  changeTimestamp: getUIProperty(state, `exhibitions/${exhibitionId}/changeTimestamp`),
  keyboardCapture: getUIProperty(state, `exhibitions/${exhibitionId}/keyboardCapture`),
});

const mapDispatch = (
  dispatch,
  { exhibitionId, placingDoor, placingWall, requestingIsEmpty, onDelete },
) => ({
  onToggleWallPlacement: () =>
    dispatch(
      setUIProperty(
        `exhibitions/${exhibitionId}/placingStructure`,
        placingWall ? undefined : 'Wall',
      ),
    ),
  onToggleDoorPlacement: () =>
    dispatch(
      setUIProperty(
        `exhibitions/${exhibitionId}/placingStructure`,
        placingDoor ? undefined : 'Door',
      ),
    ),
  selectDoor: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/selectedStructure`, 'Door')),
  selectWall: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/selectedStructure`, 'Wall')),
  requestIsEmpty: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/requestingIsEmpty`, !requestingIsEmpty)),
  onDeleteExhibition: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/onDelete`, !onDelete)),
  closeDialog: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/displayStructureDialog`, false)),
  openDialog: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/displayStructureDialog`, true)),
  onTemplateRemove: () => {
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/templatePath`, undefined));
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/selectingTemplate`, undefined));
  },
});

const mapLifeCycle = {
  onDidUpdate: (prevProps, props) => {
    if (prevProps.changeTimestamp !== props.changeTimestamp) {
      props.requestIsEmpty();
    }
  },
};

const ExhibitionSpacePanel = compose(
  withState(mapState),
  withDispatch(mapDispatch),
  withLifecycle(mapLifeCycle),
)(ExhibitionSpacePanelView);

export default ExhibitionSpacePanel;
